import { Container } from "react-grid-system";
import { HorizontalSpacer } from "../../atoms/Spacers";
import ActionButton from "../../atoms/buttons/ActionButton";
import { theme } from "../../../theme";
import { useAuth } from "../../../auth/AuthProvider";
import Subheading from "../../atoms/typography/Subheading";

export default function SignedOut() {
  const { signinRedirect } = useAuth();

  return (
    <Container>
      <HorizontalSpacer spacing={2} />
      <Subheading>You have been logged out</Subheading>
      <HorizontalSpacer spacing={2} />
      <ActionButton
        title="Logga in igen"
        onClick={() => signinRedirect()}
        color={theme.colors.primary}
      />
    </Container>
  );
}
